// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3QylG","badges":"styles_badges__1lEh2"};